module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.004,"color":"#198CDB","label":"<=0.4"},{"quantity":0.01,"color":"#91E3AD","label":"0.4-1"},{"quantity":0.02,"color":"#DEFFB0","label":"1-2"},{"quantity":0.03,"color":"#FFE68C","label":"2-3"},{"quantity":0.04,"color":"#FF9982","label":"3-4"},{"quantity":0.04,"color":"#FF4D30","label":">4"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_90_maize.json
// module id = lNAp
// module chunks = 171